export default {
  namespaced: true,
  state: {
    modal: false,
  },
  getters: {
    modal: state => state.modal,
  },
  mutations: {
    modalMutate(state, data) {
      state.modal = data;
    },
  },
  actions: {
    setModal(context, data) {
      context.commit('modalMutate', data);
    },
  },
};
